export default __webpack_public_path__ + "static/media/Conference Room 5.ae1bff0f.jpg";